/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 ~ Copyright 2021 Adobe
 ~
 ~ Licensed under the Apache License, Version 2.0 (the "License");
 ~ you may not use this file except in compliance with the License.
 ~ You may obtain a copy of the License at
 ~
 ~     http://www.apache.org/licenses/LICENSE-2.0
 ~
 ~ Unless required by applicable law or agreed to in writing, software
 ~ distributed under the License is distributed on an "AS IS" BASIS,
 ~ WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 ~ See the License for the specific language governing permissions and
 ~ limitations under the License.
 ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
import { gql } from '@apollo/client';

// TODO: updateCustomer mutation is deprecated and needs to be changed to updateCustomerV2. This new mutation doesn't
//       allow to change passwords or email address. Use updateCustomerEmail and changeCustomerPassword for this.

export default gql`
    mutation UpdateCustomerInformation($firstname: String, $lastname: String, $email: String, $password: String) {
        updateCustomer(input: { firstname: $firstname, lastname: $lastname, email: $email, password: $password }) {
            customer {
                firstname
                lastname
                email
            }
        }
    }
`;
